// extracted by mini-css-extract-plugin
export default {"buttons":"FormWizard_buttons__QDZTI","error":"FormWizard_error__Sx+Ui textSmall"};